import { useEffect, useRef, useState } from "react";
import { FiChevronDown, FiDownload, FiSearch } from "react-icons/fi";

export default function PaymentsFilters({
  filterStatus,
  setFilterStatus,
  filterBranch,
  setFilterBranch,
  filterDuration,
  setFilterDuration,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  searchText,
  setSearchText,
  fetchData,
  exportToExcel,
  totalAmount,
  patients,
  setPatients,
  setPackages,
  setTotalAmount,
  setHasSearched,
  setDateError,
  dateError,
}) {
  const [statusOpen, setStatusOpen] = useState(false);
  const [branchOpen, setBranchOpen] = useState(false);
  const [dateOpen, setDateOpen] = useState(false);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setStatusOpen(false);
        setBranchOpen(false);
        setDateOpen(false);
      }
    };
    

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
  if (searchText.trim() === "") {
    fetchData();
  }
}, [searchText]);
  const filterRef = useRef(null);

  const toggleCheckbox = (value, state, setState) => {
    if (state.includes(value)) {
      setState(state.filter((v) => v !== value));
    } else {
      setState([...state, value]);
    }
  };
  return (
    <div
      ref={filterRef}
      className="bg-white p-6 rounded-xl shadow-md border border-gray-200 mb-6"
    >
      {/* Title */}
      <div className="flex justify-between items-center mb-4">
        <div>
          <h3 className="text-lg font-semibold text-[#204080]">
            Filter Payments
          </h3>
          <p className="text-sm text-gray-500">
            Use the filters below to find patient payment records
          </p>
        </div>

        <button
          onClick={() => {
            setFilterStatus([]);
            setFilterBranch([]);
            setFilterDuration("");
            setSearchText("");
            setStartDate("");
            setEndDate("");
            setPatients([]);
            setPackages([]);
            setTotalAmount(0);
            setHasSearched(false);
            setDateError(""); // ✅ ADD THIS
          }}
          className="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300"
        >
          Reset Filters
        </button>
      </div>

      {/* STATUS CHECKBOX */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-4">
        {/* PAYMENT STATUS */}
        <div className="relative dropdown-container">
          <p className="text-sm font-semibold mb-1">Payment Status</p>

          <button
            onClick={() => {
              setStatusOpen(!statusOpen);
              setBranchOpen(false);
              setDateOpen(false); // ADD THIS
            }}
            className="border rounded-lg px-3 py-2 text-sm bg-white w-full flex justify-between items-center"
          >
            {filterStatus.length === 0 ? "Select" : filterStatus.join(", ")}
            <FiChevronDown />
          </button>

          {statusOpen && (
            <div className="absolute bg-white border rounded-lg shadow p-3 mt-1 w-full z-10 space-y-2">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={filterStatus.includes("unpaid")}
                  onChange={() =>
                    toggleCheckbox(
                      "unpaid",
                      filterStatus,
                      setFilterStatus,
                      setStatusOpen,
                    )
                  }
                />
                Unpaid
              </label>

              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={filterStatus.includes("paid")}
                  onChange={() =>
                    toggleCheckbox(
                      "paid",
                      filterStatus,
                      setFilterStatus,
                      setStatusOpen,
                    )
                  }
                />
                Paid
              </label>

              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={filterStatus.includes("package")}
                  onChange={() =>
                    toggleCheckbox(
                      "package",
                      filterStatus,
                      setFilterStatus,
                      setStatusOpen,
                    )
                  }
                />
                Package
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={filterStatus.includes("treatment")}
                  onChange={() =>
                    toggleCheckbox(
                      "treatment",
                      filterStatus,
                      setFilterStatus,
                      setStatusOpen,
                    )
                  }
                />
                Treatment
              </label>
            </div>
          )}
        </div>

        {/* BRANCH */}
        <div className="relative dropdown-container">
          <p className="text-sm font-semibold mb-1">Branch</p>

          <button
            onClick={() => {
              setBranchOpen(!branchOpen);
              setStatusOpen(false);
              setDateOpen(false); // ADD THIS
            }}
            className="border rounded-lg px-3 py-2 text-sm bg-white w-full flex justify-between items-center"
          >
            {filterBranch.length === 0 || filterBranch.length === 2
              ? "All Branches"
              : filterBranch.join(", ")}
            <FiChevronDown />
          </button>

          {branchOpen && (
            <div className="absolute bg-white border rounded-lg shadow p-3 mt-1 w-full z-10 space-y-2">
              <label className="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  checked={filterBranch.length === 0}
                  onChange={() => setFilterBranch([])}
                />
                All Branches
              </label>

              <label className="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  checked={filterBranch.includes("Gajuwaka")}
                  onChange={() =>
                    toggleCheckbox("Gajuwaka", filterBranch, setFilterBranch)
                  }
                />
                Gajuwaka
              </label>

              <label className="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  checked={filterBranch.includes("Kurmannapalem")}
                  onChange={() =>
                    toggleCheckbox(
                      "Kurmannapalem",
                      filterBranch,
                      setFilterBranch,
                      setBranchOpen,
                    )
                  }
                />
                Kurmannapalem
              </label>
            </div>
          )}
        </div>
        {/* DURATION */}
        <div>
          <p className="text-sm font-semibold mb-1">Duration</p>

          <div className="flex items-center gap-2">
            <select
              value={filterDuration}
              onChange={(e) => {
                setFilterDuration(e.target.value);
                setStatusOpen(false);
                setDateOpen(false);
                setStartDate(false);
                setEndDate(false);
              }}
              className="border rounded-lg px-3 py-2 text-sm bg-white w-full"
            >
              <option value="">Select</option>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="7">Last 7 Days</option>
              <option value="30">Last 30 Days</option>
              <option value="60">Last 60 Days</option>
            </select>

            {/* OR TEXT */}
            <span className="text-black text-xs font-bold whitespace-nowrap">
              OR
            </span>
          </div>
        </div>
        {/* START DATE */}
        <div>
          <p className="text-sm font-semibold mb-1">Start Date</p>

          <input
            type="date"
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
              setFilterDuration("");
              setStatusOpen(false);
              setDateOpen(false);
            }}
            className="border rounded-lg px-3 py-2 text-sm bg-white w-full"
          />
        </div>

        {/* END DATE */}
        <div>
          <p className="text-sm font-semibold mb-1">End Date</p>

          <input
            type="date"
            value={endDate}
            min={startDate}
            onChange={(e) => {
              setEndDate(e.target.value);
              setFilterDuration("");
              setStatusOpen(false);
              setDateOpen(false);
            }}
            className="border rounded-lg px-3 py-2 text-sm bg-white w-full"
          />
          {dateError && (
            <p className="text-red-500 text-xs mt-1">{dateError}</p>
          )}
        </div>

        {/* SEARCH ROW */}
        <div className="col-span-1 sm:col-span-2 md:col-span-5">
          <p className="text-sm font-semibold mb-1">Search</p>

          <div className="flex flex-wrap items-center gap-3">
            {/* SEARCH INPUT WITH ICON */}
            <div className="relative flex-1">
              <FiSearch className="absolute left-3 top-2.5 text-gray-400" />

              <input
  type="text"
  placeholder="Search by VPJC ID, Name or Mobile"
  value={searchText}
  onChange={(e) => setSearchText(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      fetchData(); // 🔥 trigger search
    }
  }}
  className="border rounded-lg pl-9 pr-3 py-2 text-sm bg-white w-full"
/>
            </div>

            <button
              onClick={() => {
                // ✅ Date validation
                if (
                  startDate &&
                  endDate &&
                  new Date(startDate) > new Date(endDate)
                ) {
                  setDateError("Start Date cannot be after End Date");
                  return;
                }

                setDateError(""); // clear error
                setHasSearched(true);
                fetchData();
              }}
              className="flex items-center gap-2 px-5 py-2 rounded-lg bg-[#204080] text-white text-sm hover:bg-[#163060] shadow"
            >
              <FiSearch />
              Search
            </button>

            <button
              onClick={exportToExcel}
              className="flex items-center gap-2 rounded-lg px-4 py-2 text-sm bg-green-600 text-white hover:bg-green-700 shadow"
            >
              <FiDownload />
              Export Excel
            </button>
            {filterStatus.includes("paid") && patients.length > 0 && (
              <div className="bg-green-50 border border-green-200 px-4 py-2 rounded-lg text-green-700 text-sm font-semibold">
                Total Amount: ₹{totalAmount}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
